import React from "react";
import { withPropsOnChange } from "recompose";
import { chain } from "lodash";
import SelectPlus from "react-select-plus";
import { Control } from "react-redux-form";

const AccountSelect = withPropsOnChange(
  ["accounts"],
  ({ accounts, prependCode }) => ({
    accounts: chain(accounts)
      .map((i) => {
        if (prependCode) {
          if (!i.Code) {
            return null;
          }
          return {
            ...i,
            Description: `${i.Code} - ${i.Description}`,
          };
        } else {
          return i;
        }
      })
      .transform(
        (acc, i) => {
          if (!i) return;
          const idx = {
            EXPENSE: 0,
            ASSET: 1,
            LIABILITY: 2,
            REVENUE: 3,
            EQUITY: 4,
          }[i.Class];

          if (typeof idx !== "undefined") acc[idx].options.push(i);
        },
        [
          { Description: "Expenses", options: [] },
          { Description: "Assets", options: [] },
          { Description: "Liabilities", options: [] },
          { Description: "Revenue", options: [] },
          { Description: "Equity", options: [] },
        ]
      )
      .value(),
  })
)(({ accounts, ...props }) => (
  <Control
    component={SelectPlus}
    labelKey="Description"
    valueKey="Code"
    options={accounts}
    {...props}
  />
));

export default AccountSelect;
